import { isProd } from '../utils/env';

export const WEB_URL = isProd() ? 'https://mybiteshares.com' : 'https://small-bites.com';
